<template>
  <div>
    <div class="contact-us-main-container">
      <div class="image-container">
        <img src="@/assets/contactus.jpeg" alt="Background" class="background-image-1" />
      </div>
      <div class="form-container">
        <div class="form-details">
          <h2>Get in touch today</h2>
          <p>
            "Have questions, need assistance, or ready to kickstart your project? Our team is here to help! Reach out today, and let's create something extraordinary together."
          </p>
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="form-group col-lg-6 col-sm-12 mt-4">
                <label for="formGroupExampleInput">Name</label>
                <input type="text" class="form-control rounded-5 mt-2 p-3" id="formGroupExampleInput" placeholder="Please enter name">
              </div>
              <div class="form-group col-lg-6 col-sm-12 mt-4">
                <label for="formGroupExampleInput2">Email</label>
                <input type="text" class="form-control rounded-5 mt-2 p-3" id="formGroupExampleInput2" placeholder="Please enter email">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6 col-sm-12 mt-4">
                <label for="formGroupExampleInput">Phone</label>
                <input type="number" class="form-control rounded-5 mt-2 p-3" id="formGroupExampleInput" placeholder="Please enter phone">
              </div>
              <div class="form-group col-lg-6 col-sm-12 mt-4">
                <label for="formGroupExampleInput2">Company</label>
                <input type="text" class="form-control rounded-5 mt-2 p-3" id="formGroupExampleInput2" placeholder="Please enter company name">
              </div>
            </div>
            <div class="form-group col-lg-12 mt-4 col-sm-12">
              <label for="formGroupExampleInput2">Leave us a message</label>
              <textarea class="form-control col-12 rounded-4 mt-2 p-3" placeholder="Please type your message here..." v-model="form.message"></textarea>
            </div>
            <button class="mt-4 rounded-5 btn" type="submit">Send message</button>
          </form>
        </div>
      </div>
      
    </div>

    <div class="container mt-5">
      <div class="row contact-container align-items-center">
        <div class="contact-details col-lg-6 col-sm-12">
          <h2><b>Contact Us</b></h2>
          <div class="details">
            <!-- Phone Section -->
            <div class="detail-item mt-lg-5 mt-sm-4 d-flex align-items-center">
              <img src="@/assets/contact.svg" alt="Phone Icon" class="detail-icon">
              <div>
                <!-- <p class="mt-3">Phone</p> -->
                <p class="">8888034089</p>
              </div>
            </div>

            <!-- Office Address Section -->
            <div class="detail-item mt-lg-5 mt-sm-4 d-flex align-items-center">
              <img src="@/assets/Location.svg" alt="Location Icon" class="detail-icon">
              <div>
                <!-- <p class="mt-3">Office Address</p> -->
                <p class="address">26 Kalash, Kashiko Nagar, Near Bhujbal Farm, Nashik 422009</p>
              </div>
            </div>

            <!-- Email Section -->
            <div class="detail-item mt-lg-5 mt-sm-4 d-flex align-items-center">
              <img src="@/assets/MAIL.svg" alt="Email Icon" class="detail-icon">
              <div>
                <!-- <p class="mt-3">Email</p> -->
                <p class="text-break">pratimaconstruction19@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
        <div class="map-section col-lg-6 col-sm-12">
          <iframe width="100%" height="400" frameborder="0" style="border:0; border-radius: 5px;" allowfullscreen
            :src="mapUrl"></iframe>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
      },
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.6912128577674!2d73.7759392!3d19.979484199999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeb15ca4b4f71%3A0xd4bba9c5d5974914!2s956%2F5-B%2C%20Sadashiv%20Nagar%2C%20Sadguru%20Nagar%2C%20Nashik%2C%20Maharashtra%20422009!5e0!3m2!1sen!2sin!4v1734241723302!5m2!1sen!2sin",
    };
  },
  methods: {
    submitForm() {
      alert("Form submitted!");
    },
  },
};
</script>

<style scoped>
/* Hero Section with Background Image */



.contact-us-main-container{
  /* height: 100vh;          
  width: 100%; 
  overflow: hidden;    */
  position: relative;
  height: auto;

}

.image-container {
  /* display: flex;
  justify-content: flex-start; 
  align-items: center;   
  height: 96vh;          
  width: 100%;           
  overflow: hidden;  
  position: relative; */
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);
  position: absolute;
  z-index: -10;
      
}

.background-image-1 {
  width: calc(90% - 450px);
  object-fit: cover;
  height: 100%;
}

.form-container{
  /* margin-left: 35vh; */

  height: auto;
  min-height: calc(100vh - 100px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: -10;


}

.form-details {
  background: white;
  padding: 4rem;
  border-radius: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: auto ;
  text-align: left;
  height: auto;
  overflow-y: auto;
  width: 65%;
  max-height: 80vh ;
  max-width: 900px;
  margin-right: 10%;
  scrollbar-width: none; 


}
.form-details::-webkit-scrollbar {
  display: none; 
}

@media (max-width: 991px) {

  .form-container{

    justify-content: center;
    height: auto;
  }

  .form-details{
    margin-top: 40vh;
    margin-right: 0%;
    width: 75%;
    max-height: none;
  }

  .background-image-1 {
    width: 100%;
  }
  

}

.form-details h2 {
  color:#197DCA;
  margin-bottom: 0.5rem;
  font-family: 'DM Sans';
  font-size: 56px;
  font-weight: 700;
  line-height: 48px;
  text-align: left;
  top: 137px;
  left: 666px;
}

.form-details p{
  color: #9795B5;
}

.form-details label{
  font-family: 'DM Sans';
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  color: #197DCA;
}



.form-container button {
  background: #197DCA;
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.form-container button:hover {
  background: #0056b3;
}





/* Contact Details Section */
.contact-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.contact-details {
  padding: 2rem;
  text-align: left;
  height: auto;
}

.contact-details h2 {
  font-family: 'Archivo', sans-serif;
  font-size: 64px;
  font-weight: 600;
  line-height: 1.2;
  color: #197DCA;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 15px; /* Space between icon and text */
}

.detail-item .address{
  line-height: 4.5vh;
}

.detail-icon {
  width: 8vh;
  height: 8vh;
}

.detail-item div {
  line-height: 1.5; /* Better spacing for text */
}

.detail-item p {
  margin: 0; /* Remove default margins */
  font-weight: 600;
  font-size: clamp(16px, 2.5vw, 28px);
  line-height: 100%;
  text-align: left;
  color: #171a1f;
}

.detail-item strong {
  font-size: 18px;
  color: #333; /* Darker color for headings */
}

.map-section iframe {
  width: 100%;
  height: 500px;
  border-radius: 5px;
  margin-top: 20px;
}

/* Tablet Screens */
@media (max-width: 991px) {
  .contact-details h2 {
    font-size: 52px;
  }

  .detail-item {
    font-size: 24px;
  }

  .map-section iframe {
    height: 300px;
  }
}

/* Mobile Screens */
@media (max-width: 576px) {
  .contact-container {
    flex-direction: column;
  }

  .contact-details h2 {
    font-size: 48px;
    text-align: left;
  }

  .detail-item {
    font-size: 20px;
    text-align: left;
  }

  .icon img {
    width: 24px;
    height: 24px;
  }

  .map-section iframe {
    height: 250px;
    margin-top: 10px;
  }
}


</style>
